{
    "longSHA": "d54e9cd2df7b23d51b9734d73fe4dc5c59e32e58",
    "shortSHA": "d54e9cd",
    "branch": "development",
    "authorName": "Dominik Šprohar",
    "commitTime": "Mon Oct 5 08:41:49 2026 +0000",
    "commitMsg": "Merge branch 'dominiks/pcsVoyageNbr' into 'development'\n\nfeat: add voyage id to pcs vessel visit list and view\n\nSee merge request billing/billing-rijeka!373",
    "totalCommitCount": "1"
}